import { Anchor } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { GroupSettingsTabs } from 'pages/Settings/Forms/GroupSettings.helpers';
import { useDrawerContext } from 'context/hooks';
import { useShowRestricted } from 'hooks/useShowRestricted';
import { ColumnBadge } from './ColumnBadge';

interface GroupBadgeProps {
  label?: string;
  groupId?: string;
}

export const GroupBadge = ({ label, groupId }: GroupBadgeProps) => {
  const navigate = useNavigate();
  const { closeDrawer } = useDrawerContext();
  const { showRestricted } = useShowRestricted();

  const handleClick = (e: React.MouseEvent) => {
    if (groupId && !showRestricted) {
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo(0, 0);
      closeDrawer();
      navigate(`/settings/${groupId}/${GroupSettingsTabs.General}`);
    }
  };

  return (
    <Anchor onClick={(e: React.MouseEvent) => handleClick(e)} key={groupId}>
      <ColumnBadge label={label} />
    </Anchor>
  );
};
